import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import styles from './PackSettings.module.scss';
import axios from 'axios';

import { useApolloClient } from '@apollo/react-hooks';
import { GET_S3_UPLOAD_QUERY } from '../../../../services/graphql';
import CardDesignAndName from '../card-design-and-name/CardDesignAndName';

const PackSettings = forwardRef((props, ref) => {
    const [title, setTitle] = useState(props.rewardPack.name || '');
    const [packBackFile, setPackBackFile] = useState('');
    const [packDesignFile, setPackDesignFile] = useState('');
    const [packPreviewFile, setPackPreviewFile] = useState('');
    const [packBackUrl, setPackBackUrl] = useState(props.rewardPack.coverImageUrl || '');
    const [packDesignUrl, setPackDesignUrl] = useState(props.rewardPack.designImageUrl || '');
    const [packPreviewUrl, setPackPreviewUrl] = useState(props.rewardPack.previewImageUrl || '');
    const [isPackBackUrlLoading, setIsPackBackUrlLoading] = useState(false);
    const [isPackDesignUrlLoading, setIsPackDesignUrlLoading] = useState(false);
    const [isPackPreviewUrlLoading, setIsPackPreviewUrlLoading] = useState(false);
    const client = useApolloClient();

    const onSelectFile = (files, objectName) => {
        if (files.length) {
            if (objectName === 'cardBackResources') {
                setIsPackBackUrlLoading(true);
            } else if (objectName === 'packDesignResources') {
                setIsPackDesignUrlLoading(true);
            } else {
                setIsPackPreviewUrlLoading(true);
            }
            const extension = files[0].name.split('.').pop().toLowerCase();
            const filename = `${objectName}-${new Date().getTime()}.${extension}`;
            client
                .query({
                    query: GET_S3_UPLOAD_QUERY,
                    variables: {
                        name: filename,
                        fileType: extension,
                        object: objectName,
                    },
                })
                .then((r) => {
                    const options = {
                        headers: {
                            'Content-Type': '',
                            'x-amz-acl': 'public-read',
                        },
                    };
                    axios
                        .put(r.data.s3UploadUrlFor.uploadUrl, files[0], options)
                        .then((s3r) => {
                            if (objectName === 'cardBackResources') {
                                setPackBackUrl(r.data.s3UploadUrlFor.uploadUrl.split('?')[0]);
                                setIsPackBackUrlLoading(false);
                            } else if (objectName === 'packDesignResources') {
                                setPackDesignUrl(r.data.s3UploadUrlFor.uploadUrl.split('?')[0]);
                                setIsPackDesignUrlLoading(false);
                            } else {
                                setPackPreviewUrl(r.data.s3UploadUrlFor.uploadUrl.split('?')[0]);
                                setIsPackPreviewUrlLoading(false);
                            }
                        });
                });
        }
    };

    useEffect(() => {
        if (!packBackFile) return;

        onSelectFile(packBackFile, 'cardBackResources');
    }, [packBackFile]);

    useEffect(() => {
        if (!packDesignFile) return;

        onSelectFile(packDesignFile, 'packDesignResources');
    }, [packDesignFile]);

    useEffect(() => {
        if (!packPreviewFile) return;

        onSelectFile(packPreviewFile, 'previewPackResources');
    }, [packPreviewFile]);

    useEffect(() => {
        if (!props.isNewPack) return;

        props.onPackDesignUrlChange(packDesignUrl);
    }, [packDesignUrl, props.isNewPack]);

    useImperativeHandle(ref, () => ({
        getData: () => ({
            title,
            packBackUrl,
            packDesignUrl,
            packPreviewUrl
        }),
    }));

    return <>
        <form>
            <div className='basic-form__group'>
                <input
                    value={title || ''}
                    name='title'
                    placeholder='Type your title for the card pack here'
                    className='basic-form__text-box'
                    type='text'
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>
        </form>
        <div className={styles.packArtWorkContainer}>
            <CardDesignAndName
                title="Card Back"
                setFiles={setPackBackFile}
                artWorkPreviewUrl={packBackUrl}
                artWorkLoading={isPackBackUrlLoading}
            />
            <CardDesignAndName
                title="Pack Design"
                setFiles={setPackDesignFile}
                artWorkPreviewUrl={packDesignUrl}
                artWorkLoading={isPackDesignUrlLoading}
            />

            <CardDesignAndName
                title="Pack preview"
                setFiles={setPackPreviewFile}
                artWorkPreviewUrl={packPreviewUrl}
                artWorkLoading={isPackPreviewUrlLoading}
            />
        </div>
    </>
});

export default PackSettings;